
export const INTEGRATION_CONSTANTS = {
    URL_CODE: "code",
    URL_ERROR: "error",
    URL_ERROR_DESCRIPTION: "error_description",
    URL_SCOPE: "scope",
    NEC_FORM: "NEC",
    MISC_FORM: "MISC",
    REALME_ID: "realmId",
    URL_STATE: "state",
    URL_ISS: "iss",
    CURRENT_TAXYEAR: "2023",
    PREVIOUS_TAXYEAR: "2022",
    NEC_FORM_TYPE: "1099-NEC",
    MISC_FORM_TYPE: "1099-MISC",
    INTEGRATION_PARAM: "integration",
    SAGEINTACCT_TEXT: "Sage Intacct",
    NETSOUITE_TEXT: "Net Suite",
    PAYER_ID_PARAM: "PayerId",
    FORM_TYPE_PARAM: "FormType",
    TAXYEAR_PARAM: "TaxYear",
    QBD_TEXT: "qbd",
    SOURCE_TEXT: "Source",
    QBD_BASE: "Qbd",
    FRESHBOOKS_BUTTON_LABEL: "Link To FreshBooks",
    XERO_BUTTON_LABEL: "Link To Xero",
    ZOHO_BUTTON_LABEL: "Link To Zoho",
    LOCAL_STORAGE_TTL: 300000,
    PAYERDATA_SESSION_KEY: "StoredPayerData",
    ENTITY_TYPE: 'Entity Type',
    PAYER_TYPE: 'Payer Type',
    INDIVIDUAL: 'Individual',
    CCORP: 'Ccorp',
    SCORP: 'Scorp',
    PARTNERSHIP: 'Partnership',
    LLC: 'LLC',
    TRUST: 'Trust',
    OTHER:'Other',
}
export const SOURCE_CONSTANTS = {
    XERO_SOURCE: "XERO",
    QBO_SOURCE: "QBO",
    FRESHBOOKS_SOURCE: "FreshBooks",
    SAGE_SOURCE: "SAGEINTACCT",
    NETSUITE_SOURCE: "NETSUITE",
    QBD_WBCONNECTOR_SOURCE: "QBDWEBCONNECTOR",
    QBD_PLUGIN_SOURCE: "QBDPLUGIN",
    QBD_EXCELIMPORT_SOURCE: "QBDEXCELIMPORT",
    ZOHO_SOURCE: "ZOHO",
    TIPALTI_SOURCE: "TIPALTI",
    ENTRATA_SOURCE: "ENTRATA",
    ACCOUNTINGSUITE_SOURCE: "ACCOUNTINGSUITE"

}

export const INTEGRATION_WRAPPER_LOADING_STATES = {
    GRID_LOADING: "GRID_LOADING",
    GRID_DATA_READY: "GRID_DATA_READY",
    GET_FORM_SETTINGS_LOADING: "GET_FORM_SETTINGS_LOADING",
    GET_FORM_SETTINGS_READY: "GET_FORM_SETTINGS_READY",
}

export const INTEGRATION_WRAPPER_LOADING_STATES_MESSAGE_MAP = {
    [INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING]: "Loading Grid Data...",
    [INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY]: "",
}
export const QBO_LOADING_STATES = {
    PRE_LOADING: "PRELOADING",
    GRID_LOADING: "GRID_LOADING",
    GRID_DATA_READY: "GRID_DATA_READY",
    GET_FORM_SETTINGS_LOADING: "GET_FORM_SETTINGS_LOADING",
    GET_FORM_SETTINGS_READY: "GET_FORM_SETTINGS_READY",
    MATCHFIELDS_LOADING: "QBOMATCHFIELDS_LOADING",
    MATCHFIELDS_DATA_READY: "QBOMATCHFIELDS_DATA_READY",
}

export const QBO_LOADING_STATES_MESSAGE_MAP = {
    [QBO_LOADING_STATES.PRE_LOADING]: "",
    [QBO_LOADING_STATES.GRID_LOADING]: "Loading Grid Data...",
    [QBO_LOADING_STATES.GRID_DATA_READY]: "",
    [QBO_LOADING_STATES.MATCHFIELDS_LOADING]: "Loading....",
    [QBO_LOADING_STATES.MATCHFIELDS_DATA_READY]: "",
}
export const INTEGRATION_LOADING_STATES = {
    PAGE_LOADING: "GRID_LOADING",
    PAGE_DATA_READY: "GRID_DATA_READY",
    FILE_UPLOADING: "FILE_UPLOADING",
    FILE_UPLOADING_READY: "FILE_UPLOADING_READY",
    GET_FORM_SETTINGS_LOADING: "GET_FORM_SETTINGS_LOADING",
    GET_FORM_SETTINGS_READY: "GET_FORM_SETTINGS_READY",
}

export const INTEGRATION_LOADING_STATES_MESSAGE_MAP = {
    [INTEGRATION_LOADING_STATES.PAGE_LOADING]: "Loading ...",
    [INTEGRATION_LOADING_STATES.PAGE_DATA_READY]: "",
    [INTEGRATION_LOADING_STATES.FILE_UPLOADING]: "File Uploading ...",
    [INTEGRATION_LOADING_STATES.FILE_UPLOADING_READY]: "",
}

export const QBD_LOADING_STATES = {
    DROPDOWNS_LOADING: " DROPDOWNS_LOADING",
    DROPDOWNS_DATA_READY: "DROPDOWNS_DATA_READY",
    PAGE_LOADING: "GRID_LOADING",
    PAGE_DATA_READY: "GRID_DATA_READY",
    FILE_DOWNLOADING: "FILE_DOWNLOADING",
    FILE_DOWNLOADING_READY: "FILE_DOWNLOADING_READY",
    GET_FORM_SETTINGS_LOADING: "GET_FORM_SETTINGS_LOADING",
    GET_FORM_SETTINGS_READY: "GET_FORM_SETTINGS_READY",
}

export const QBD_LOADING_STATES_MESSAGE_MAP = {
    [QBD_LOADING_STATES.DROPDOWNS_LOADING]: "",
    [QBD_LOADING_STATES.DROPDOWNS_DATA_READY]: "",
    [QBD_LOADING_STATES.PAGE_LOADING]: "Loading ...",
    [QBD_LOADING_STATES.PAGE_DATA_READY]: "",
    [QBD_LOADING_STATES.FILE_DOWNLOADING]: "File Downloading ...",
    [QBD_LOADING_STATES.FILE_DOWNLOADING_READY]: "",
}

export const TIPALTI_LOADING_STATES = {
    DROPDOWNS_LOADING: " DROPDOWNS_LOADING",
    DROPDOWNS_DATA_READY: "DROPDOWNS_DATA_READY",
    PAGE_LOADING: "GRID_LOADING",
    PAGE_DATA_READY: "GRID_DATA_READY",
    FILE_DOWNLOADING: "FILE_DOWNLOADING",
    FILE_DOWNLOADING_READY: "FILE_DOWNLOADING_READY",
    GET_FORM_SETTINGS_LOADING: "GET_FORM_SETTINGS_LOADING",
    GET_FORM_SETTINGS_READY: "GET_FORM_SETTINGS_READY",
}

export const TIPALTI_LOADING_STATES_MESSAGE_MAP = {
    [TIPALTI_LOADING_STATES.DROPDOWNS_LOADING]: "",
    [TIPALTI_LOADING_STATES.DROPDOWNS_DATA_READY]: "",
    [TIPALTI_LOADING_STATES.PAGE_LOADING]: "Loading ...",
    [TIPALTI_LOADING_STATES.PAGE_DATA_READY]: "",
    [TIPALTI_LOADING_STATES.FILE_DOWNLOADING]: "File Downloading ...",
    [TIPALTI_LOADING_STATES.FILE_DOWNLOADING_READY]: "",
}

export const BILL_LOADING_STATES = {
    PAGE_LOADING: "GRID_LOADING",
    PAGE_DATA_READY: "GRID_DATA_READY",
}
export const BILL_LOADING_STATES_MESSAGE_MAP = {
    [BILL_LOADING_STATES.PAGE_LOADING]: "Loading ...",
    [BILL_LOADING_STATES.PAGE_DATA_READY]: "",
}
export const FORM_IDS = {
    $1099NEC: 47,
    $1099MISC: 1,
}